<template>
  <el-aside class="index-aside" :width="isCollapse ? '64px' : '210px'" :class="{collapse: isCollapse}">
    <div class="index-aside-inner menulist">
      <div v-for="item in menuList" :key="item.roleName" v-if="role==item.roleName" class="menulist-item">
        <el-menu 
          :mode="2 == 1? 'horizontal':'vertical'" 
          :unique-opened="true" 
          class="el-menu-demo" 
          default-active="0"
          :collapse="isCollapse"
          :collapse-transition="false"
        >
          <el-menu-item index="0" @click="menuHandler('')">
            <i v-if="false" class="el-icon-menu el-icon-s-home" />
            <span slot="title">首页</span>
          </el-menu-item>
          <el-submenu index="1">
            <template slot="title">
				<i v-if="false" class="el-icon-menu el-icon-user-solid" />
				<span>个人中心</span>
            </template>
            <el-menu-item index="1-0" @click="menuHandler('updatePassword')">
              <i class="el-icon-key"></i>
              <span slot="title">修改密码</span>
            </el-menu-item>
            <el-menu-item index="1-1" @click="menuHandler('center')">
              <i class="el-icon-user"></i>
              <span slot="title">个人信息</span>
            </el-menu-item>
          </el-submenu>
          <el-submenu v-for=" (menu,index) in item.backMenu" :key="menu.menu" :index="index+2+''">
            <template slot="title">
				<i v-if="false" class="el-icon-menu" :class="icons[index]" />
				<span>{{ menu.menu }}</span>
            </template>
            <el-menu-item v-for=" (child,sort) in menu.child" :key="sort" :index="(index+2)+'-'+sort" @click="menuHandler(child.tableName)">
              <i :class="getIconClass(index)"></i>
              <span slot="title">{{ child.menu }}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </el-aside>
</template>

<script>
import menu from '@/utils/menu'
export default {
  data() {
    return {
      menuList: [],
      dynamicMenuRoutes: [],
      role: '',
      isCollapse: false, // 侧边栏折叠状态
      icons: [
        'el-icon-s-cooperation',
        'el-icon-s-order',
        'el-icon-s-platform',
        'el-icon-s-fold',
        'el-icon-s-unfold',
        'el-icon-s-operation',
        'el-icon-s-promotion',
        'el-icon-s-release',
        'el-icon-s-ticket',
        'el-icon-s-management',
        'el-icon-s-open',
        'el-icon-s-shop',
        'el-icon-s-marketing',
        'el-icon-s-flag',
        'el-icon-s-comment',
        'el-icon-s-finance',
        'el-icon-s-claim',
        'el-icon-s-custom',
        'el-icon-s-opportunity',
        'el-icon-s-data',
        'el-icon-s-check',
        'el-icon-s-grid',
        'el-icon-menu',
        'el-icon-chat-dot-square',
        'el-icon-message',
        'el-icon-postcard',
        'el-icon-position',
        'el-icon-microphone',
        'el-icon-close-notification',
        'el-icon-bangzhu',
        'el-icon-time',
        'el-icon-odometer',
        'el-icon-crop',
        'el-icon-aim',
        'el-icon-switch-button',
        'el-icon-full-screen',
        'el-icon-copy-document',
        'el-icon-mic',
        'el-icon-stopwatch',
      ],
      menulistStyle: '${template.back.menulist.menulistStyle}',
	  menulistBorderBottom: {},
    }
  },
  mounted() {
    const menus = menu.list()
    if(menus) {
        this.menuList = menus
    } else {
        let params = {
            page: 1,
            limit: 1,
            sort: 'id',
        }
        this.$http({
            url: "menu/list",
            method: "get",
            params: params
        }).then(({
            data
        }) => {
            if (data && data.code === 0) {
                this.menuList = JSON.parse(data.data.list[0].menujson);
                this.$storage.set("menus", this.menuList);
            }
        })
    }
    this.role = this.$storage.get('role')
    
    // 监听侧边栏折叠事件
    this.$bus.$on('toggleSidebar', (isCollapse) => {
      this.isCollapse = isCollapse;
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$bus.$off('toggleSidebar');
  },
  created(){
    setTimeout(()=>{
      this.menulistStyleChange()
    },10)
    this.icons.sort(()=>{
      return (0.5-Math.random())
    })
	this.lineBorder()
  },
  methods: {
    // 获取图标类名
    getIconClass(index) {
      return this.icons[index % this.icons.length];
    },
	lineBorder() {
		let style = '${template.back.menulist.menulistStyle}'
		let w = '${template.back.menulist.menulistLineWidth}'
		let s = '${template.back.menulist.menulistLineStyle}'
		let c = '${template.back.menulist.menulistLineColor}'
		if(style == 'vertical') {
			this.menulistBorderBottom = {
				borderBottomWidth: w,
				borderBottomStyle: s,
				borderBottomColor: c
			}
		} else {
			this.menulistBorderBottom = {
				borderRightWidth: w,
				borderRightStyle: s,
				borderRightColor: c
			}
		}
	},
    menuHandler(name) {
      let router = this.$router
      name = '/'+name
      router.push(name)
    },
    // 菜单
    setMenulistHoverColor(){
      let that = this
	  return;
      this.$nextTick(()=>{
        document.querySelectorAll('.menulist .el-menu-item').forEach(el=>{
          el.addEventListener("mouseenter", e => {
            e.stopPropagation()
            el.style.backgroundColor = "${template.back.menulist.menulistHoverColor}"
          })
          el.addEventListener("mouseleave", e => {
            e.stopPropagation()
            // el.style.backgroundColor = "${template.back.menulist.menulistBgColor}"
			el.style.background = "none"
          })
          el.addEventListener("focus", e => {
            e.stopPropagation()
            el.style.backgroundColor = "${template.back.menulist.menulistHoverColor}"
          })
        })
        document.querySelectorAll('.menulist .el-submenu__title').forEach(el=>{
          el.addEventListener("mouseenter", e => {
            e.stopPropagation()
            el.style.backgroundColor = "${template.back.menulist.menulistHoverColor}"
          })
          el.addEventListener("mouseleave", e => {
            e.stopPropagation()
            // el.style.backgroundColor = "${template.back.menulist.menulistBgColor}"
			el.style.background = "none"
          })
        })
      })
    },
    setMenulistIconColor() {
      this.$nextTick(()=>{
        document.querySelectorAll('.menulist .el-submenu__title .el-submenu__icon-arrow').forEach(el=>{
          el.style.color = "${template.back.menulist.menulistIconColor}"
        })
      })
    },
    menulistStyleChange() {
      this.setMenulistIconColor()
      this.setMenulistHoverColor()
      this.setMenulistStyleHeightChange()
      let str = "2"
      if(1 == str) {
        this.$nextTick(()=>{
          document.querySelectorAll('.el-container .el-container').forEach(el=>{
            el.style.display = "block"
            el.style.paddingTop = "60px" // header 高度
          })
          document.querySelectorAll('.el-aside').forEach(el=>{
            el.style.width = "100%"
            el.style.height = "auto"
            el.style.paddingTop = '0'
          })
          document.querySelectorAll('.index-aside .index-aside-inner').forEach(el=>{
            el.style.paddingTop = '0'
			el.style.width = "100%"
          })
        })
      }
      if(2 === str) {
        this.$nextTick(()=>{
          document.querySelectorAll('.index-aside .index-aside-inner').forEach(el=>{
            el.style.paddingTop = "50px"
          })
        })
      }
    },
    setMenulistStyleHeightChange() {
		return;
      this.$nextTick(()=>{
        document.querySelectorAll('.menulist-item>.el-menu--horizontal>.el-menu-item').forEach(el=>{
          el.style.height = "${template.back.menulist.menulistHeight}"
          el.style.lineHeight = "${template.back.menulist.menulistHeight}"
        })
        document.querySelectorAll('.menulist-item>.el-menu--horizontal>.el-submenu>.el-submenu__title').forEach(el=>{
          el.style.height = "${template.back.menulist.menulistHeight}"
          el.style.lineHeight = "${template.back.menulist.menulistHeight}"
        })
      })
    },
  }
}
</script>
<style lang="scss" scoped>
	.el-container {
		display: block;
	}
  .index-aside {
    position: relative;
    overflow: hidden;
    background-color: #304156;
    box-shadow: 2px 0 6px rgba(0,21,41,.35);
    transition: width 0.3s;

    &.collapse {
      width: 64px !important;
      
      .menulist-item {
        width: 64px !important;
      }
    }

    .index-aside-inner {
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      padding-top: 50px;
      box-sizing: border-box;
      background-color: #304156;

      &:focus {
        outline: none;
      }

      & ::v-deep .el-menu {
        border: 0;
        background-color: transparent;
      }
      
      // 若依风格 - 滚动条样式
      &::-webkit-scrollbar {
        width: 6px;
      }
      
      &::-webkit-scrollbar-thumb {
        background-color: rgba(255,255,255,0.2);
        border-radius: 3px;
      }
      
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
    }
		
    .index-aside .index-aside-inner.menulist {
      height: auto !important;
    }

    .menulist-item {
      width: 210px;
      min-height: calc(100vh - 50px);
      background-color: #304156;
      transition: width 0.3s;
    }
    
    .el-menu-demo {
      background-color: #304156;
      
      // 若依风格 - 折叠时的样式
      &.el-menu--collapse {
        width: 64px;
        
        .el-submenu__title {
          padding: 0 !important;
          
          span {
            display: none;
          }
        }
        
        .el-menu-item {
          padding: 0 !important;
          
          span {
            display: none;
          }
        }
      }
      
      &>.el-menu-item {
        color: #bfcbd9;
        font-size: 14px;
        transition: all 0.3s;
        
        &:hover {
          background-color: #263445 !important;
          color: #fff;
        }
        
        &.is-active {
          background-color: #409EFF !important;
          color: #fff;
        }
      }
      
      .el-submenu {
        & ::v-deep .el-submenu__title {
          color: #bfcbd9;
          font-size: 14px;
          transition: all 0.3s;
          
          &:hover {
            background-color: #263445 !important;
            color: #fff;
          }
          
          .el-submenu__icon-arrow {
            color: #bfcbd9;
          }
        }
      }
      
      & ::v-deep .el-menu.el-menu--inline {
        background-color: #1f2d3d !important;
        
        .el-menu-item {
          color: #bfcbd9;
          font-size: 13px;
          padding-left: 50px !important;
          transition: all 0.3s;
          
          &:hover {
            background-color: #001528 !important;
            color: #fff;
          }
          
          &.is-active {
            background-color: #001528 !important;
            color: #409EFF;
          }
        }
      }
    }
  }
</style>
<style>
.el-menu--horizontal .el-menu--popup {
  width: 100%;
  background-color: #1f2d3d !important;
  border: none;
}

.el-menu--horizontal .el-menu--popup .el-menu-item {
  color: #bfcbd9 !important;
  background-color: transparent !important;
}

.el-menu--horizontal .el-menu--popup .el-menu-item:hover {
  background-color: #001528 !important;
  color: #fff !important;
}
</style>
